import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'orders',
    collectionActionName: 'ORDERS',
    itemActionName: 'ORDER',
});
